module.exports = __webpack_public_path__ + "img/500x500-01.70abf349.jpg";